import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppDataService } from 'src/app/core/app-data/app-data.service';
type Coverage = { [key: string]: any }

@Injectable({
    providedIn: 'root'
})
export class CoverageTermService {

  private quoteCoverageTermsCache: Map<number, Coverage[]> = new Map<number, Coverage[]>();

  constructor(private appDataService: AppDataService) { }

  public replaceCurrentCoverageOptions(quoteId: number, coverageOptions: Coverage[]): void {
      if (!quoteId) return;
      // Don't cache empty results: an empty fetch would otherwise lock the
      // Plan Term dropdown empty/disabled on every reopen.
      if (!coverageOptions || coverageOptions.length === 0) return;
      this.quoteCoverageTermsCache.clear();
      this.quoteCoverageTermsCache.set(quoteId, [...coverageOptions]);
  }

  public getCachedCoverageOptions(quoteId: number): Coverage[] | null {
      if (!quoteId) return null;
      const cached = this.quoteCoverageTermsCache.get(quoteId);
      return cached && cached.length > 0 ? [...cached] : null;
  }

  public clearCachedCoverageOptions(quoteId: number): void {
      if (!quoteId) return;
      this.quoteCoverageTermsCache.delete(quoteId);
  }

  public getCoverageOptions(program: string, saleType: string, manufacturer: string, equipType: string, model: string,hours: number,serialNumber: string | null, ratingType: string, warranties: Array<{term: number, hours: number, coverage: string}> = []): Observable<Coverage[]> {
      // * encodeURIComponent: ensure special characters (&*%+|) are being sending properly
      const stringWarranties = warranties.map(w => `${w.term},${w.hours},${encodeURIComponent(w.coverage)}`).join('|').toString();
        return this.appDataService.get<Coverage[]>('api/v1/espp/coverage_terms',{
          program,
          quote_type: saleType,
          manufacturer,
          rating_type: ratingType,
          equip_type: equipType,
          model,
          hours,
          serial_number: serialNumber ?? '',
          warranties: stringWarranties
        });
    }
}
